import BaseRepository from 'Domain/Repositories/BaseRepository/BaseRepository';
import { Event }   from 'Domain/Models';

const config = {
    model: Event,
    baseRoute: '/admin/event',
    singular: 'event',
    plural: 'events',
}

class EventRepository extends BaseRepository<Event, typeof config.singular, typeof config.plural> {

  cancelEvent(id: number) {
    return this.makeRequest({
      path: `${this.baseRoute}/cancel/${id}`,
      type: 'POST',
      callback: this.initializeSingleModel,
    });
  }

  downloadEventReport(id: number) {
    return this.makeRequest({
      path: `${this.baseRoute}/${id}/download-report-pdf`,
      type: 'GET',
      callback: this.downloadFile('application/pdf'),
    });
  }

  sendBuyerMail(id: string, data: { subject: string, message: string, eventTicketId?: string }) {
    return this.makeRequest({
      path: `${this.baseRoute}/${id}/send-buyer-mail`,
      type: 'POST',
      data,
      callback: (response: { recipientCount: number }) => response,
    });
  }

  findEmployees(id: string) {
    return this.makeRequest({
      path: `${this.baseRoute}/${id}/employee`,
      type: 'GET',
      callback: ({ userIds = [] }: { userIds: string[] }) => ({ userIds })
    });
  }

  updateEmployees(id: string, userIds: string[]) {
    return this.makeRequest({
      path: `${this.baseRoute}/${id}/employee`,
      type: 'PATCH',
      data: { userIds },
      callback: ({ userIds: assignedUserIds = [] }: { userIds: string[] }) => ({ userIds: assignedUserIds })
    });
  }

}

export default new EventRepository(config);
